import { Check } from 'lucide-react';
import { Button } from '../../../../design-system/button/button';
import { Inline } from '../../../../design-system/inline/inline';
import { Stack } from '../../../../design-system/stack/stack';

type SuccessStepProps = {
  recipientName: string;
  amount: string;
  reference: string;
  onViewPayment: () => void;
  onMakeNewPayment: () => void;
};

export const SuccessStep = ({
  recipientName,
  amount,
  reference,
  onViewPayment,
  onMakeNewPayment,
}: SuccessStepProps) => {
  return (
    <Stack align="stretch" space={16} className="w-full rounded-lg bg-white p-8">
      <Stack space={3} align="center">
        <Inline justify="center" className="h-20 w-20 rounded-full border border-seapoint-yellow bg-white p-4">
          <Check size={30} />
        </Inline>

        <Stack space={2} align="center">
          <p className="text-xl font-medium text-black">Transfer successful</p>

          <p className="text-center text-base font-medium leading-6 tracking-tight text-seapoint-gray-text">
            This can take a few hours to arrive depending on the recipient's bank.
          </p>
        </Stack>
      </Stack>

      <Stack space={6} align="stretch">
        <Stack space={3} align="stretch">
          <Inline justify="between">
            <p className="text-base font-medium text-seapoint-gray-text">Recipient name</p>

            <p className="text-base font-medium text-black">{recipientName}</p>
          </Inline>

          <Inline justify="between">
            <p className="text-base font-medium text-seapoint-gray-text">Amount</p>

            <p className="text-base font-medium text-black">{amount}</p>
          </Inline>

          {/* Prevents showing empty reference field */}
          {!!reference && (
            <Inline justify="between">
              <p className="text-base font-medium text-seapoint-gray-text">Reference</p>

              <p className="text-base font-medium text-black">{reference}</p>
            </Inline>
          )}
        </Stack>

        <Stack space={3} align="stretch">
          <Button variant="default" onClick={onViewPayment}>
            View payment
          </Button>

          <Button variant="secondary" onClick={onMakeNewPayment}>
            Make a new payment
          </Button>
        </Stack>
      </Stack>
    </Stack>
  );
};
